import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4aa8a75e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4aa8a75e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa8a75e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aa8a75e')) {
      api.createRecord('4aa8a75e', component.options)
    } else {
      api.reload('4aa8a75e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4aa8a75e&scoped=true&", function () {
      api.rerender('4aa8a75e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/camp/index.vue"
export default component.exports